import { SET_INITIAL_TEXT_CONTENTS, TextContentsActions } from '../actions/text-contents-action'
import { ITextContentState } from "../types";
import { defaultTextContents } from '../../service/TextContentsService'

export function textContentReducer(state: ITextContentState = defaultTextContents, action: TextContentsActions) {
  switch (action.type) {
    case SET_INITIAL_TEXT_CONTENTS: {
      return {
         ...state,
         loaders: action.payload.loaders,
         errorPage: action.payload.errorPage,
         failPage: action.payload.failPage,
         manualVerificationPage: action.payload.manualVerificationPage,
         contractSigningPage: action.payload.contractSigningPage,
         bmVerifyPage: action.payload.bmVerifyPage,
         offertPage: action.payload.offertPage,
         buttons: action.payload.buttons,
         modals: action.payload.modals,
         clientPeselReservedPage: action.payload.clientPeselReservedPage,
         contractDonePage: action.payload.contractDonePage,
         clientChoiceVerificationPage: action.payload.clientChoiceVerificationPage,
         videoVerificationStartPage: action.payload.videoVerificationStartPage,
         mObywatelIdentityPage : action.payload.mObywatelIdentityPage,
         customClientOfferPage: action.payload.customClientOfferPage,
         predefinedOfferPage: action.payload.predefinedOfferPage,
      };
    }
    default:{
      return state;
    }
  }
}